import { Button, ButtonGroup, TextField, Box } from "@mui/material";
import React from "react";
import { RangePricingTable } from "./RangePricingTable";

export const FinalSelection = (props) => {
  const {
    quantity,
    onQuantityChange,
    onPopUp,
    note,
    onNoteChange,
    settings,
    rangePrice,
  } = props;

  const increaseCounter = () => {
    const newValue = quantity || 0;
    onQuantityChange(newValue + 1);
  };

  const decreaseCounter = () => {
    const newValue = quantity || 0;
    const value = newValue - 1;
    if (value > 0) {
      onQuantityChange(value);
    } else {
      onPopUp("Quantity cannot be 0.", false);
    }
  };

  const handleNumberCharge = (e) => {
    const value = e.target.value;
    onQuantityChange(value);
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", mt: 2 }}>
      {settings?.showSpecialPricing == 1 && rangePrice.length > 0 ? (
        <RangePricingTable rangePrice={rangePrice} />
      ) : null}
      {/* {settings?.showNotes == 1 ? ( */}
      <TextField
        id="itemNotes"
        label="Note"
        multiline
        rows={4}
        placeholder="..."
        value={note}
        onChange={(e) => onNoteChange(e)}
      />
      {/* ) : null} */}

      <div
        style={{
          marginTop: "10px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <label>Quantity:</label>
        <ButtonGroup
          variant="contained"
          aria-label="outlined primary button group"
          sx={{
            height: "56px",
          }}
        >
          <Button sx={{ minWidth: "65px" }} onClick={() => decreaseCounter()}>
            -
          </Button>
          <TextField
            id="quantity"
            type="number"
            disabled={true}
            inputProps={{ style: { textAlign: "center" } }}
            sx={{ textAlign: "center", width: "65px" }}
            onChange={handleNumberCharge}
            value={quantity}
          />
          <Button sx={{ minWidth: "65px" }} onClick={() => increaseCounter()}>
            +
          </Button>
        </ButtonGroup>
      </div>
    </Box>
  );
};
